export enum CameraKey {
  CAMERA_ENABLED = "cameraEnabled",
  CAMERA_IP_ADRESS = "cameraIP",
  CAMERA_IP_PORT = "cameraPort",
  CAMERA_AUTO_AFTER_MEASUREMENT = "cameraAutoAfterMeasurement",
  CAMERA_AUTO_AFTER_BARCODE_SCAN = "cameraAutoAfterBarcodeScan",
  CAMERA_DELAY_BEFORE_CAPTURE = "cameraDelay",
  IMAGE_2D_ENABLED = "2DImageEnabled",
  DESTINATION_FOLDER = "destinationFolder",
  AXIS_PASSWORD = "axisPassword",
  AXIS_USERNAME = "axisUsername",
  CAMERA_LIVE_VIDEO_URL = "cameraLiveVideoURL",
  CAMERA_CAPTURE_URL = "cameraCaptureURL",
  AUTHORIZE = "authorizeCameraConnection"
}
